import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Search from 'flarum/forum/components/Search';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import AdvancedSearchModal from './AdvancedSearchModal';
export default function extendSearch() {
  // 1. Add filter/sliders button inside the Search component input in the header
  extend(Search.prototype, 'view', function (vdom) {
    if (!vdom || !vdom.children || !Array.isArray(vdom.children)) {
      return;
    }
    const inputWrapper = vdom.children.find(child => child && child.attrs && child.attrs.className && child.attrs.className.includes('Search-input'));
    if (inputWrapper && Array.isArray(inputWrapper.children)) {
      const alreadyHasAdvanced = inputWrapper.children.some(child => child && child.attrs && child.attrs.className && child.attrs.className.includes('Search-advanced'));
      if (!alreadyHasAdvanced) {
        inputWrapper.children.push(m("button", {
          className: "Search-advanced Button Button--icon Button--link",
          type: "button",
          title: app.translator.trans('nagusi-match-ratings.forum.search.advanced_title') || 'Búsqueda avanzada',
          "aria-label": app.translator.trans('nagusi-match-ratings.forum.search.advanced_title') || 'Búsqueda avanzada',
          onclick: e => {
            e.preventDefault();
            e.stopPropagation();
            const initialQuery = (this.searchState && this.searchState.getValue ? this.searchState.getValue() : '') || (app.search && app.search.state && app.search.state.getValue ? app.search.state.getValue() : '') || m.route.param('q') || '';
            app.modal.show(AdvancedSearchModal, {
              initialQuery
            });
          }
        }, m("i", {
          className: "fas fa-sliders-h"
        })));
      }
    }
  });

  // 2. Add "Búsqueda avanzada / Refinar búsqueda" in the toolbar of IndexPage
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const currentQ = (app.search && app.search.state && app.search.state.getValue ? app.search.state.getValue() : '') || m.route.param('q') || '';
    const isSearching = !!currentQ;
    items.add('advancedSearch', m(Button, {
      className: "Button Button--advanced-search",
      icon: "fas fa-sliders-h",
      onclick: () => {
        app.modal.show(AdvancedSearchModal, {
          initialQuery: currentQ
        });
      }
    }, isSearching ? app.translator.trans('nagusi-match-ratings.forum.search.refine_button') || 'Refinar búsqueda' : app.translator.trans('nagusi-match-ratings.forum.search.advanced_title') || 'Búsqueda avanzada'), 40);
  });

  // 3. Remove duplicate search and refresh from actionItems on IndexPage toolbar
  extend(IndexPage.prototype, 'actionItems', function (items) {
    items.remove('search');
    items.remove('refresh');
  });

  // 4. Ensure header search input reflects current query whenever IndexPage initializes
  extend(IndexPage.prototype, 'oninit', function () {
    const q = m.route.param('q') || '';
    if (app.search && app.search.state && typeof app.search.state.setValue === 'function') {
      app.search.state.setValue(q);
    }
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/search/extendSearch', extendSearch);